import { Box } from '@mantine/core'
import { type ReactNode } from 'react'

import { useResizeHandler } from './hooks/useResideHandler'
import classes from './styles.module.css'

type ContentWithSidebarMobileProps = {
  content: ReactNode
  sidebar: ReactNode
}

export function ContentWithSidebarMobile({
  content,
  sidebar,
}: ContentWithSidebarMobileProps) {
  const { dragContainerRef, dragHandlerRef, handleStartResizing } =
    useResizeHandler()

  return (
    <Box className={classes.pageContentWrapperMobile}>
      <Box>{content}</Box>
      <Box
        className={classes.pageSidebarWrapperDraggable}
        ref={dragContainerRef}
      >
        <Box
          ref={dragHandlerRef}
          className={classes.pageSidebarWrapperDraggableHandler}
          onTouchStart={handleStartResizing}
        />
        {sidebar}
      </Box>
    </Box>
  )
}
